var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSymbol(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 73,
    height: 73,
    viewBox: "0 0 73 73",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M63.3594 16.75C68.2812 16.75 72.5 20.8281 72.5 25.75C72.5 29.125 70.6719 32.0781 68 33.625V49.375C68 62.4531 56.8906 73 43.25 73C29.75 73 18.7812 62.875 18.5 50.0781C8.23438 47.9688 0.5 38.9688 0.5 28V6.20312C0.5 4.65625 1.625 3.25 3.17188 2.82812L12.0312 1.14062C13.8594 0.71875 15.5469 1.98438 15.9688 3.8125L16.3906 6.0625C16.8125 7.89062 15.5469 9.57812 13.7188 10L9.35938 10.8438V28C9.35938 35.5938 15.5469 41.6406 23 41.5C30.4531 41.5 36.3594 35.3125 36.3594 27.8594V10.8438L32.1406 10C30.3125 9.57812 29.0469 7.75 29.4688 5.92188L29.8906 3.8125C30.3125 1.98438 32 0.71875 33.8281 1.14062L42.6875 2.96875C44.2344 3.25 45.5 4.65625 45.5 6.20312V28C45.5 38.9688 37.7656 47.9688 27.5 50.0781C27.7812 57.8125 34.8125 64 43.25 64C51.8281 64 59 57.5312 59 49.375V33.625C56.1875 32.0781 54.3594 28.9844 54.5 25.6094C54.5 20.8281 58.4375 16.8906 63.3594 16.75ZM63.5 28C64.625 28 65.75 27.0156 65.75 25.75C65.75 24.625 64.625 23.5 63.5 23.5C62.2344 23.5 61.25 24.625 61.25 25.75C61.25 27.0156 62.2344 28 63.5 28Z",
    fill: "#5E2866"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSymbol);
export default __webpack_public_path__ + "static/media/Symbol.c22bb9ea09ae9c7613fb777e290bc2cf.svg";
export { ForwardRef as ReactComponent };